import clsx from 'clsx';
import React, { useState } from 'react';
import { Button, Modal, Nav, OverlayTrigger, Tooltip } from 'react-bootstrap';
import InputField from '../../../../../components/molecules/InputField';

const DesignEditorParams = ({ params }) => {
    const [showModal, setShowModal] = useState(false);
    const [tab, setTab] = useState('default');

    const fieldTemplate = (variables) => {
        return Object.entries(variables).map(([key, value], index) => {
            return (
                <React.Fragment key={index}>
                    {typeof value !== 'object' && (
                        <li>
                            <div className='input-group input-group-sm'>
                                <span className='input-group-text border-gray-200 w-25 rounded-0'>
                                    {key}
                                </span>
                                <InputField
                                    defaultValue={value}
                                    config={{
                                        name: value,
                                        className: 'form-control-sm rounded-0 w-75 border-gray-200',
                                    }}
                                />
                            </div>
                        </li>
                    )}
                    {typeof value === 'object' &&
                        !Array.isArray(value) &&
                        !['dev', 'uat', 'prod'].includes(key) && (
                            <li>
                                <h6 className='bg-light-info border fs-8 p-2 my-2 text-info'>
                                    <i className='bi-diagram-3-fill me-2'></i>
                                    {key}
                                </h6>
                                <ul>{fieldTemplate(value)}</ul>
                            </li>
                        )}
                </React.Fragment>
            );
        });
    };

    return (
        <>
            <OverlayTrigger
                placement='top'
                overlay={<Tooltip>Edit Params</Tooltip>}>
                <button
                    className={clsx(
                        `btn btn-icon btn-xs shadow shadow-sm border me-2 border-gray-400 border-dotted`
                    )}>
                    <i
                        className='ki-duotone ki-data fs-3'
                        onClick={() => setShowModal(true)}></i>
                </button>
            </OverlayTrigger>
            <Modal
                show={showModal}
                dialogClassName='modal-custom w-90'
                onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Parameters</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <>
                        <ul className='navpills mt-5 mx-7 p-0'>
                            {[
                                { value: 'default', label: 'Design Params' },
                                { value: 'dev', label: 'Dev Environment' },
                                { value: 'prod', label: 'Prod Environment' },
                            ]
                                .filter((str) => str)
                                .map((row) => {
                                    return (
                                        <li
                                            key={row}
                                            className='navpills__item'
                                            onClick={() => setTab(row.value)}>
                                            <span
                                                className={`fs-9 navpills__item__link ${
                                                    tab === row.value
                                                        ? 'navpills__item__link-active'
                                                        : ''
                                                }`}>
                                                {row.label}
                                            </span>
                                        </li>
                                    );
                                })}
                        </ul>
                        <div className='mt-10'>
                            <ul className='tree'>
                                <>
                                    {fieldTemplate(
                                        tab === 'default' ? params : params?.[tab] || {}
                                    )}
                                </>
                            </ul>
                        </div>
                    </>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant='secondary'>Close</Button>
                    <Button variant='primary'>Save changes</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};
export default DesignEditorParams;
